import React, { useEffect, useMemo, useState } from "react";
import { Modal } from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { fetchSingleWocommCategory } from "../../../actions/wocommerce-categories/wocommerceCategories";

export function WoCommCategoryViewDialog({ history, match}) {

  const dispatch = useDispatch();
  const id = match.params.id

  const onHide=()=>{
      history.push("/wocommerce-categories")
  }

  useEffect(() => {
    if (!id) {
      onHide();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const { categoryForEdit } = useSelector(
    (state) => ({
        categoryForEdit: id ? state.wocommerceCategories && state.wocommerceCategories.categoryForEdit : undefined,
    }),
    shallowEqual
  );

  const [loading, setLoading] = useState(false);
  useMemo(async () => {
    
    setLoading(true)
    await dispatch(fetchSingleWocommCategory(id));
    setLoading(false)

  }, [id, dispatch]); 


  let name = '';
  let order = '';
  if (categoryForEdit) {
    name = categoryForEdit.category_name;
    order = categoryForEdit.order;
  }
  return (
    <Modal
      show={categoryForEdit}
      onHide={onHide}
      aria-labelledby='example-modal-sizes-title-lg'>
      {loading}
      <Modal.Header closeButton>
        <Modal.Title id='example-modal-sizes-title-lg'>
          View Wocommerce Category Details
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>          
        <div className="form-group row">
          <div className='col-lg-12'>
            <label><strong> Category Name</strong></label>
            <input type="text" className="form-control" value={name} readOnly/>
          </div>
        </div>
        <div className="form-group row">
          <div className='col-lg-12'>
            <label><strong> Category Order</strong></label>
            <input type="text" className="form-control" value={order} readOnly/>
          </div>

        </div>
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button
            type='button'
            onClick={onHide}
            className='btn btn-light btn-elevate'>
            Cancel
          </button>
          <> </>
        </div>
      </Modal.Footer>
    </Modal>
  );
}